/**
 * 匿名登录
 * 开平token获取
 * 获取用户信息
 */
import { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { isHarmony, isNative } from '@whelk/const/src/env';

import { h5Bridge } from '@whelk/utils/src/bridge/callH5Bridge';
import { login, setInitUserLoading } from '@whelk/store/slices/userSlice';
import { initSentryUserParams } from '@whelk/utils/src/sentry';
import { onClearUserInfo } from '@whelk/utils';
import {
  setIsShowRetryButton,
  setIsShowShareButton,
  setNativeStyle,
  setNegativeReviewsList,
} from '@whelk/store/slices/configSlice';
import { NATIVE_NETWORK_PUBLIC_HEADER, NATIVE_NETWORK_PUBLIC_PARAMS } from '@whelk/const/src/token';
import i18n, { LOCALE_MAP } from '@whelk/utils/src/i18n';
import { nativeBridge } from '@whelk/utils/src/bridge/callNativeBridge';
import { useRouter } from './useRouter';
import { NegativeReview } from '@whelk/services/src/common';

const useInitNative = () => {
  const dispatch = useDispatch();
  const nav = useRouter();

  const setUserInfo = (data: any) => {
    // 2匿名 1正式
    dispatch(login({ ...data, isAnonymous: data?.loginStatus === 2, userName: data?.webName }));
    initSentryUserParams(data);
  };

  const setChatConfig = (data: {
    statusBarHeight: number;
    navigationBarHeight: number;
    indicatorHeight: number;
    negativeReviewsList: NegativeReview;
  }) => {
    const statusBarHeight = data.statusBarHeight ?? 0;
    const navigationBarHeight = data.navigationBarHeight ?? 0;
    const indicatorHeight = data.indicatorHeight ?? 0;
    dispatch(
      setNativeStyle({
        statusBarHeight: Math.max(0, Math.round(statusBarHeight)),
        navigationBarHeight: Math.max(Math.round(indicatorHeight), Math.round(navigationBarHeight)),
      }),
    );
    dispatch(setNegativeReviewsList(data?.negativeReviewsList));
  };

  const onLogout = () => {
    onClearUserInfo();
    if (isHarmony) {
      nav.replace('/');
    }
  };

  const setShowRetryButton = (show: boolean) => {
    dispatch(setIsShowRetryButton(show ?? true));
  };

  const setShowShareButton = (show: boolean) => {
    dispatch(setIsShowShareButton(show ?? true));
  };

  const setNetCommonParams = (data: { queryMap: any; headerMap: any }) => {
    const queryMap = JSON.stringify(data.queryMap ?? {});
    const headerMap = JSON.stringify(data.headerMap ?? {});
    localStorage.setItem(NATIVE_NETWORK_PUBLIC_PARAMS, queryMap);
    localStorage.setItem(NATIVE_NETWORK_PUBLIC_HEADER, headerMap);
    const language =
      Object.values(LOCALE_MAP).find((lang) => data.queryMap.sys_language?.startsWith(lang)) ||
      LOCALE_MAP.ZH_HANS;
    if (language !== i18n.language) {
      i18n.changeLanguage(language);
    }
  };

  const initH5BridgeMethod = () => {
    h5Bridge.batchAddBridgeApi({
      onLogout: onLogout,
      setUserInfo: setUserInfo,
      setShowShareButton: setShowShareButton,
      setShowRetryButton: setShowRetryButton,
      setNetCommonParams: setNetCommonParams,
      setChatConfig: setChatConfig,
    });
  };

  useEffect(() => {
    if (isNative) {
      dispatch(setInitUserLoading(false));
      initH5BridgeMethod();
      nativeBridge.callNative({ methodName: 'onPageReady' });
    }
    return () => {
      if (isNative) {
        h5Bridge.clearH5Bridge();
        localStorage.clear();
      }
    };
  }, []);
};

export default useInitNative;
